import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface Gallery {
  title: string;
  icon: string;
}

@Component({
  selector: 'fcp-staging-gallery',
  templateUrl: './staging-gallery.component.html',
  styleUrls: ['./staging-gallery.component.scss']
})
export class StagingGalleryComponent {
  @Input() public gallery: Array<Gallery>;
  @Output() public selectedImage: EventEmitter<string> = new EventEmitter();
  public selected: string;

  constructor() {
  }

  selectImage(id: string) {
    if (this.selected !== id) {
      this.selected = id;
    } else {
      this.selected = '';
    }
  }
}
